<template>
    <div class="other-tenant-item-content other-tenant-interface-call">
        <div class="interface-call-bar">
            <span class="other-tenant-title">接口调用统计</span>
            <span class="other-tenant-title interface-change-title">{{this.currentInterface}}</span>
            <div :class="[callType,'interface-call-tab']">
                <span @click="tabChange('call-type-search')" class="interface-call-tab-item call-type-search-item">查询</span>
                <span @click="tabChange('call-type-gather')" class="interface-call-tab-item call-type-gather-item">采集</span>
                <span @click="showDialog" class="run-hole-button">接口调用报表</span>
            </div>
            <el-carousel ref="carousel" :interval="20000" arrow="never" @change="carouselChange">
                <el-carousel-item name='call-type-search'>
                    <div class="interface-call-item">
                        <div class="interface-call-echarts">
                            <div id="interfaceCallBar"></div>
                        </div>
                        <div class="interface-call-bar-list">
                            <ul>
                                <li class="interface-call-bar-list-item" v-for="(item,index) in searchBopLost.slice(0,5)" :key="index" @click="jumpBridge">
                                    <div class="interface-call-bar-list-left">
                                        <img class="interface-call-bar-list-img" src="../../../../../../assets/images/plaint.svg" width="16" height="14" alt="">
                                        <span class="interface-call-bar-list-tittle" :title="item.apiName">{{item.apiName}}</span>
                                    </div>
                                    <div class="interface-call-bar-list-num">{{item.failCount}}</div>
                                </li>
                            </ul>
                            <span v-show="isSearchInterface" class="bar-list-more" @click="openDeatil('searchBopLost')">查看更多
                                <img src="../../../../../../assets/images/arrow.svg" width="20" height="10" alt="">
                            </span>
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item name="call-type-gather">
                    <div class="interface-call-item">
                        <div class="interface-call-echarts">
                            <div id="interfaceCallGather"></div>
                        </div>
                        <div class="interface-call-bar-list">
                            <ul>
                                <li class="interface-call-bar-list-item" v-for="(item,index) in collectBopLost.slice(0,5)" :key="index" @click="jumpBridge">
                                    <div class="interface-call-bar-list-left">
                                        <img class="interface-call-bar-list-img" src="../../../../../../assets/images/plaint.svg" width="16" height="14" alt="">
                                        <span class="interface-call-bar-list-tittle" :title="item.apiName">{{item.apiName}}</span>
                                    </div>
                                    <div class="interface-call-bar-list-num">{{item.failCount}}</div>
                                </li>
                            </ul>
                            <span v-show="isgatherInterface" class="bar-list-more" @click="openDeatil('collectBopLost')">查看更多
                                <img src="../../../../../../assets/images/arrow.svg" width="20" height="10" alt="">
                            </span>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <el-dialog
            width="500px"
            :title="this.dialogTitle"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false">
            <el-table :data="tableData" height="300" class="interface-call-table" @row-click="jumpBridge">
                <el-table-column prop="apiName" label="接口名称"></el-table-column>
                <el-table-column prop="failCount" label="数量" width="100"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog class="Interface-statistics" width="863px" height="466px" title="接口调用统计"
            :visible.sync="InterfaceStatisticsDialog" :close-on-click-modal="true" @close="closeInterfaceStatisticsDialog">
            <mTable
                ref="InterfaceStatistics"
                :config="tableConfig"
                :pageTotal="pageTotal"
                :tableData="InterfaceStatisticstableData"
                @cascadeChange="cascadeChange"
                @onSearchChange="onSearchChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange">
                <div slot="table-module-btn-left">
                    <el-button class="darkBtV3" @click="restSearchChange">重置</el-button>
                </div>
                <div slot="table-module-btn">
                    <el-button icon="el-icon-upload2" size="mini" class="uploadBtV3" @click="searchExport"></el-button>
                </div>
            </mTable>
        </el-dialog>
    </div>
</template>
<script>
import { getInCallOptions } from './interfaceCallOptions';
import mTable from '@/modules/sn/components/IdentityComponent/Main';
import { config } from './tableConfig.js';
import { mapGetters } from 'vuex';
import { getCallSituationApi, getProtName } from '../../../../../../api/afterLoginIndex';
import { exportType } from '../../../../../../api/logManagement';

export default {
    components: { mTable },
    computed: {
        ...mapGetters(['currentTenant']),
        isSearchInterface() {
            return this.searchBopLost.length > 5;
        },
        isgatherInterface() {
            return this.collectBopLost.length > 5;
        },
        currentInterface() {
            return this.callType === 'call-type-search' ? '查询接口调用异常重点关注榜' : '采集接口调用异常重点关注榜';
        }
    },
    data() {
        return {
            callType: 'call-type-search',
            dialogVisible: false,
            tableData: [],
            dialogTitle: '',
            searchInterfaceList: [],
            gatherInterfaceList: [],
            collectBopLost: [],
            searchBopLost: [],
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            tableConfig: config,
            InterfaceStatisticstableData: [],
            InterfaceStatisticsDialog: false
        };
    },
    methods: {
        conversionSystem (dictArray) {
            const dictArr = [];
            dictArray.forEach(element => {
                if (element['code']) {
                    dictArr.push({
                        label: element['code'],
                        value: element['code']
                    });
                };
            });
            return dictArr;
        },
        cascadeChange(val, configuration) {
            if (!configuration.iscascade) {
                return;
            };
            this.pageNo = 1;
            this.pageSize = 10;
            const { tenantCode } = this.currentTenant;
            const dictCode = 'BOP_COLLECT_FLAG';
            const name = val;
            getProtName({ tenantCode, dictCode, name }).then(res => {
                if (res && +res.code === 0) {
                    const resoptions = this.conversionSystem(res.data.list);
                    this.tableConfig.searchList.searchTxt[1].options = resoptions;
                }
            });
        },
        closeInterfaceStatisticsDialog() {
            this.InterfaceStatisticsDialog = false;
            this.InterfaceStatisticstableData = [];
        },
        searchExport() {
            const { tenantCode } = this.currentTenant;
            const { apiName, createTime, dataType } = this.searchData || {};
            const [ startTime, endTime ] = createTime || [];
            if (!apiName && !startTime) {
                this.$message.warning('请先查询再导出');
                return;
            };
            const params = {
                apiName,
                tenantCode,
                startTime,
                endTime
            };
            const url = `/api-sn/tenantIndex/bopDownExport?dataType=${dataType}`;
            const type = 'post';
            const name = '接口调用统计.xls';
            exportType(params, url, type, name);
        },
        showDialog() {
            this.restSearchChange();
            this.tableConfig.searchList.searchTxt[1].options = [];
            this.InterfaceStatisticsDialog = true;
        },
        restSearchChange() {
            if (this.$refs.InterfaceStatistics) {
                this.$refs.InterfaceStatistics.$refs.SearchLsit.restSearchChange();
            };
        },
        loadData() {
            const { tenantCode } = this.currentTenant;
            const { apiName, createTime, dataType } = this.searchData;
            if (!createTime) {
                this.$message.warning('请选择你的查询时间');
                return;
            };
            if (!dataType) {
                this.$message.warning('请选择你的接口类型');
                return;
            };
            const sTime = Date.parse(createTime[0]);
            const eTime = Date.parse(createTime[1]);
            const diff = ((eTime - sTime) / 3600 / 1000 / 24);
            if (Math.ceil(diff) >= 185) {
                this.$message.warning('选取间隔不能超过6个月');
                return;
            };
            const [ startTime, endTime ] = createTime;
            const params = {
                apiName,
                tenantCode,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                startTime,
                endTime
            };
            const returnListObject = {
                '采集类': 'collectBopStatistics',
                '查询类': 'searchBopStatistics'
            };
            getCallSituationApi(params, dataType).then(res => {
                if (res && +res.code === 0) {
                    const currentType = res.data[returnListObject[dataType]] || {};
                    const { list, totalCount } = currentType;
                    list.forEach(item => { item.dataType = dataType; });
                    this.InterfaceStatisticstableData = [].concat(list);
                    this.pageTotal = totalCount;
                };
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        onSearchChange(data) {
            this.pageNo = 1;
            this.pageSize = 10;
            this.searchData = data;
            this.loadData();
        },
        drawSearchEcharts() {
            let myChart = this.$echarts.init(document.getElementById('interfaceCallBar'));
            if (myChart) { myChart.dispose(); }
            myChart = this.$echarts.init(document.getElementById('interfaceCallBar'));
            // 绘制图表
            this.$nextTick(() => {
                myChart.setOption(getInCallOptions(this.searchBopStatistics));
            });
        },
        drawGatherEcharts() {
            let myChart = this.$echarts.init(document.getElementById('interfaceCallGather'));
            if (myChart) { myChart.dispose(); }
            myChart = this.$echarts.init(document.getElementById('interfaceCallGather'));
            // 绘制图表
            this.$nextTick(() => {
                myChart.setOption(getInCallOptions(this.collectBopStatistics));
            });
        },
        tabChange(type) {
            this.callType = type;
            this.$refs.carousel.setActiveItem(type);
        },
        carouselChange(index) {
            this.callType = index ? 'call-type-gather' : 'call-type-search';
        },
        openDeatil(type) {
            this.tableData = this[type];
            this.dialogTitle = this.currentInterface;
            this.dialogVisible = true;
        },
        jumpBridge() {
            window.open('/network.html#/interface-log', '_blank');
        },
        formatWarnData(array) {
            const formatArray = [];
            const dataArray = JSON.parse(JSON.stringify(array));
            const filterArray = dataArray.sort((a, b) => b.failCount - a.failCount);
            filterArray.forEach(item => {
                if (item.failCount) {
                    item.failCount = item.failCount.toLocaleString();
                    formatArray.push(item);
                }
            });
            return formatArray;
        },
        dataProcess(data) {
            this.collectBopStatistics = data.collectBopStatistics.list || [];
            this.searchBopStatistics = data.searchBopStatistics.list || [];
            this.collectBopLost = this.formatWarnData(this.collectBopStatistics);
            this.searchBopLost = this.formatWarnData(this.searchBopStatistics);
            this.$nextTick(() => {
                this.drawSearchEcharts();
                this.drawGatherEcharts();
            });
        }
    }
};
</script>
<style lang="less">
.other-tenant-interface-call{
    display: flex;
    height: 316px;
    .interface-change-title{
        position: absolute;
        left: calc(68% + 64px);
        top: 0;
    }
    .interface-call-bar{
        width: 100%;
        position: relative;
    }
    .interface-call-tab{
        position: absolute;
        z-index: 99;
        display: flex;
        // width: 160px;
        height: 24px;
        box-sizing: border-box;
        border-radius: 2px;
        // border: 1px solid #4285f5 ;
        cursor: pointer;
    }
    .run-hole-button {
        border: 1px solid #4285f5 ;
        cursor: pointer;
        font-size: 12px;
        color: #4285f5;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        margin-left: 6px;
    }
    .interface-call-tab-item{
        width: 50%;
        height: 100%;
        text-align: center;
        line-height: 22px;
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 12px;
        color: #ffffff;
        font-weight: 400;
        background: #ffffff;
        color: #4285f5;
        width: 60px;
        border: 1px solid #4285f5 ;
        box-sizing: border-box;
    }
    .el-carousel{
        height: calc(100% - 42px)!important;
        .el-carousel__container{
            height: 100%!important;
        }
    }
    .interface-call-item{
        display: flex;
        height: 100%;
        justify-content: space-between;
    }
    .interface-call-echarts{
        cursor: pointer;
        height: 100%;
        width: 68%;
    }
    .interface-call-bar-list{
        width: calc(32% - 64px);
    }
    #interfaceCallBar,#interfaceCallGather{
        width: 100%;
        height: 100%;
    }
    .el-carousel__indicators{
        display: none;
    }
    .echarts-tooltip-box{
        padding: 10px 12px;
        font-family: 'PingFangSC-Medium', sans-serif;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 24px;
        font-weight: 500;
        >span{
            display: block;
            line-height: 12px;
            margin-bottom: 8px;
        }
    }
    .call-type-search .call-type-search-item,
    .call-type-gather .call-type-gather-item{
        background: #4285F5;
        color: #fff;
    }
    .interface-call-bar-list-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 12px;
        line-height: 40px;
        color: #333333;
        font-weight: 400;
        cursor: pointer;
    }
    .interface-call-bar-list-img{
        margin-right: 8px;
        vertical-align: middle;
    }
    .interface-call-bar-list-tittle{
        vertical-align: middle;
        display: inline-block;
        width: calc(100% - 25px);
        overflow:hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
    }
    .interface-call-bar-list-left{
        width: calc(100% - 60px);
    }
    .interface-call-bar-list-num{
        color: #ff3c3c;
        font-weight: 600;
        font-size: 14px;
        font-family: 'PingFangSC-Medium', sans-serif;
    }
    .bar-list-more{
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 10px;
        width: 111px;
        height: 24px;
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        box-shadow: 0px 2px 4px 1px rgba(43,131,253,0.1);
        border-radius: 2px;
        cursor: pointer;
    }
    .Interface-statistics {
        .nPanel .el-table {
            height: 292px !important;
        }
    }
}
</style>
